angular.module('impactx.disposition').controller('DispositionDoneListCtrl', [
    '$mdDialog',
    '$scope',
    '$redirect',
    DispositionDoneListCtrl]);

function DispositionDoneListCtrl($mdDialog, $scope, $redirect)
{
    var ctrl = this;
    this.status = "done";
    $scope.$watch(function() {
        return ctrl.status;
    }, function(current, original) {
        if (current == "wait")
            $redirect.redirectTo(null,"/dispositionwait");
    });

    this.itemDetails = function(ev, dispositionId)
    {
        $mdDialog.show({
                controller: "DispositionDoneDialogCtrl",
                templateUrl: 'modules/disposition/templates/dispositionworkdialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dispositionId: dispositionId
                }
            })
            .then(function (answer)
            {
            });
    };
    this.meta = {
        rowTemplate: 'modules/disposition/templates/dispositionworklist.row.tmpl.html',
        filtersTemplate: 'modules/disposition/templates/dispositionworklist.filters.tmpl.html',
        isSelectAble: false,
        endpoint: '/disposition/dispositiondone',
        ctrl: this,
        id: "dispositiondone"
    };
    this.getMeta = function ()
    {
        return this.meta;
    };
}
